import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dialog } from '@/shared/ui/dialogs/Dialog';
import { Button } from '@/shared/ui/buttons/Button';
import { PlusIcon } from '@/shared/ui/icons';

type ParcelCreateGateDialogProps = {
  open: boolean;
  onClose: () => void;
};

/**
 * Dialog shown when the user attempts to create a parcel but has no APPROVED Cargo ID
 * (status is REJECTED or null). The PENDING state is handled with a toast at the
 * call-site — this dialog assumes the user can act (request a Cargo ID).
 */
export const FeaturesCargoIdParcelCreateGateDialog = ({
  open,
  onClose,
}: ParcelCreateGateDialogProps) => {
  const { t } = useTranslation('cargoId');
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('parcelGate.dialogTitle')}
      description={t('parcelGate.dialogDescription')}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose}>
            {t('parcelGate.cancel')}
          </Button>
          <Button
            leftIcon={<PlusIcon className="h-4 w-4" />}
            onClick={() => {
              onClose();
              navigate('/ids/request');
            }}
          >
            {t('parcelGate.getCta')}
          </Button>
        </>
      }
    >
      <span className="sr-only">{t('parcelGate.dialogDescription')}</span>
    </Dialog>
  );
};
